
const serviceRequireFiled = {
    unit:{code: 'unit', name: '箱型', type: 'field', field: 'unit'},
    departurePort: {code: 'departurePortKey', name: '起运港', type: 'field', field: 'departurePortId'},
    sendType: {code: 'sendType', name: '运输方式', type: 'field',field: 'transportationMethod'},
    refundOrNot: {code: 'refundOrNot', name: '税金', type: 'field',field: 'isTaxReimbursement'},
    category: {code: 'category', name: '品名类别', type: 'field',field: 'productNameType'},
    channelName: {code: 'channelName', name: '渠道名称', type: 'field',field: 'channelName'},
    regionPost: {code: 'regionPost', name: '邮编', type: 'field',field: 'postalCode'},
    destinationPort: {code: 'destinationPortKey', name: '目的港', type: 'field',field: 'destinationPortId'},
    fclInstallList: {
        code: 'fclInstallList',
        field: 'loadingFullContainerList',
        name: '整柜',
        type: 'list',
        children: [{code: 'unit', name: '箱型', type: 'field',field: 'box'},
            {code: 'unitNum', name: '箱量', type: 'field',field: 'teu'},
            {code: 'weight', name: '毛重', type: 'field',field: 'grossWeight'},
            {code: 'zgRegion', name: '装柜区域', type: 'field', field: 'containerLoadingAddress'}]
    },
    // storeArea 是交货仓 sourceStoreArea 是接货仓
    arriveStore: {code: 'storeArea', name: '交货仓', type: 'field',field: 'deliveryWarehouse'},
    sourceStore: {code: 'sourceStoreArea', name: '接货仓', type: 'field',field: 'receivingWarehouse'},
    cgStore: {code: 'sourceStore', name: '拆柜仓库', type: 'field',field: 'dismantlingWarehouse'},
    cgStoreId: {code: 'sourceStoreId', name: '拆柜仓库', type: 'field',field: 'dismantlingWarehouseId'},
    grossWeight: {code: 'grossWeight', name: '毛重', type: 'field',field: 'totalGrossWeight'},
    cbm: {code: 'cbm', name: '体积', type: 'field',field: 'totalVolume'},
    ctns: {code: 'ctns', name: '件数', type: 'field',field: 'totalNumberOfPieces'},
    eta: {code: 'eta', name: 'ETA/到港日', type: 'field',field: 'arrivalDate'},
    fclArriveList: {
        code: 'fclArriveList',
        field: 'loadingFullContainerList',
        name: '整柜',
        type: 'list',
        children: [
            {code: 'unit', name: '箱型', type: 'field',field: 'box'},
            {code: 'unitNum', name: '箱量', type: 'field',field: 'teu'},
            {code: 'weight', name: '毛重', type: 'field',field: 'grossWeight'}]
    },
    productCardFclQueryList:{
        code: 'productCardFclQueryList',
        field: '$.destInfo',
        name: '目的地代码',
        type: 'list',
        children: [
            {code: 'addressCode', name: '地址代码', type: 'field',field: 'destinationCode'},
            {code: 'detailAddress', name: '信息地址', type: 'field',field: 'destinationAddress'},
            {code: 'region', name: '地址区域', type: 'field',field: 'destinationArea'},
            {code: 'regionPost', name: '邮编', type: 'field',field: 'postalCode'}]
    },
    regionFclArriveList: {
        code: 'fclArriveList',
        field: 'loadingFullContainerList',
        name: '整柜',
        type: 'list',
        children: [
            {code: 'unit', name: '箱型', type: 'field',field: 'box'},
            {code: 'unitNum', name: '箱量', type: 'field',field: 'teu'},
            {code: 'weight', name: '毛重', type: 'field',field: 'grossWeight'},
            {code: 'region', name: '目的地', type: 'field',field: 'packingRegion'}]
    },
    gnkcList: {
        code: 'fclInstallList',
        field: 'loadingFullContainerList',
        name: '整柜',
        type: 'list',
        children: [
            {code: 'unit', name: '箱型', type: 'field',field: 'box'},
            {code: 'unitNum', name: '箱量', type: 'field',field: 'teu'},
            {code: 'weight', name: '毛重', type: 'field',field: 'grossWeight'},
            {code: 'zgRegion', name: '装柜地址', type: 'field', field: 'packingRegion'}]
    },
    region: {code: 'region', name: '目的地区域', type: 'field',field: 'destinationLocation'},
}

const constants = {
    loginCookieKey: "kx",
    menuStoreKey: 'menu',
    pageOptStoreKey: 'pageOpt',
    LoginUserStoreKey: 'clientLoginUser',
    menuLinkOperationKeyPrefix: 'operation-',
    dictStoreKey: 'dictCache',// 字典缓存key
    regionStoreKey: 'regionList',// 地区缓存key
    entrustedBusStoreKey: 'entrustedBusList',// 委托业务类型缓存key
    currencyStoreKey: 'currencyList',// 币种汇率缓存key
    worldPortStoreKey: 'worldPortList',
    storeStoreKey: 'storeList',
    countryStoreKey:'countryStoreList',//国家
    allFclUnitStoreKey: 'allFclUnitList',// 箱型箱量
    allAllUnitStoreKey:'allAllUnitList',//所有单位
    userStoreKey: 'userList',// 用户缓存key
    multiUserStoreKey: 'multiUserList',// 用户缓存key
    orgStoreKey: 'orgList',// 用户缓存key
    roleStoreKey: 'roleList',// 角色缓存key
    categoryStoreKey: 'categoryList',// 品名类型
    objList: 'objList',// 对象
    planQueryTmpKey: "planQueryTmpKey",
    addressCodeKey:'addressCodeList',//地址编码
    carrierCodeKey:'carrierSelectList',//承运人
    channelCodeKey:'channelSelectList',//渠道
    customerLevelCodKey:'customerLevelList', //客户等级
    get company(){
        let item = window.localStorage.getItem("clientCompanyInfo");
        if (item) {
            return JSON.parse(item)
        }
        return {companyId:"",companyFullName:''};
    },
    get clientLoginUser(){
        let item = window.localStorage.getItem("clientLoginUser");
        if (item) {
            return JSON.parse(item)
        }
        return {id:""};
    },
    taxesList: [{isTaxes: true, taxes: "有"},
        {isTaxes: false, taxes: "无"}],
    // 散货整柜常量
    goodsTypes: [
        {code: 1, name: "整柜"},
        {code: 2, name: "散货"},
    ],
    shippingTypesForFOB: [
        {code: 'SEA', name: "海运"},
        {code: 'RAILWAY', name: "铁路"},
        {code: 'MORE', name: "多式联运"},
    ],
    shippingTypesForCFRFCL:[
        {code: 'SEA', name: "海运"},
        {code: 'RAILWAY', name: "铁路"},
        {code: 'MORE', name: "多式联运"},
    ],
    shippingTypesForCFRBULK:[
        {code: 'SEA', name: "海运"},
        {code: 'RAILWAY', name: "铁路"},
        {code: 'AIR', name: "空运"},
        {code: 'MORE', name: "多式联运"},
    ],
    shippingTypes: [
        {code: 'SEA', name: "海运"},
        {code: 'RAILWAY', name: "铁路"},
        {code: 'AIR', name: "空运"},
        {code: 'LAND', name: "陆运"},
        {code: 'MORE', name: "多式联运"},
    ],
    serviceTypes: [
        {code: 'GATE', name: "门点服务"},
        {code: 'BASE', name: "基础服务"},
        {code: 'CROSS', name: "跨境服务"},
    ],
    unitTypes: {
        TUE:{id:"645ca0cdccd441e1f08c3cdb",name:"TUE"},
        KG:{id:"645a12a0225250214094685b",name:"KG"},
        CBM:{id:"645a12bf2252502140946862",name:"CBM"},
        TICKET:{id:"645a130c225250214094687b",name:"票"}
    },
    unitList: [
        {id:"645ca0cdccd441e1f08c3cdb",name:"TUE"},
        {id:"645a12a0225250214094685b",name:"KG"},
        {id:"645a12bf2252502140946862",name:"CBM"},
        {id:"645a130c225250214094687b",name:"票"}
        ],

    entrustedBuss: {
        FOB: {
            1: {
                plan: [{
                    serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                        {code: "GNBG",name: "报关服务",type: "single",require:true}], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.category,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.fclInstallList
                ]
            }
        },
        CFR: {
            1: {
                plan: [{
                    serviceList: [
                        {code: "GNKC", name: "国内卡车", type: "single",require:false},
                        {code: "GNBG",name: "报关服务",type: "single",require:false},
                        {group: [{code: "SEA", name: "海运服务", type: "single"},
                            {code: "RAILWAY",name: "铁路服务",type: "single"},
                            {code: "MORE", name: "多式联运", type: "single"}],
                        name: "港到港",
                        select: "radio",
                        type: "group",
                        require:true
                    }], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList
                ]
            },
            2: {
                plan: [{
                    serviceList: [{code: "GNBG", name: "报关服务", type: "single",require:false}, {
                        group: [{code: "SEA", name: "海运服务", type: "single" },
                            {code: "RAILWAY", name: "铁路服务", type: "single"},
                            { code: "AIR",name: "空运服务",type: "single"},
                            {code: "MORE", name: "多式联运", type: "single"}],
                        name: "港到港",
                        select: "radio",
                        type: "group",
                        require:true
                    }], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.grossWeight,
                    serviceRequireFiled.cbm,
                    serviceRequireFiled.ctns,
                ]
            },

        },
        CIF: {
            1: {
                plan: [{
                    serviceList: [
                        {code: "GNKC", name: "国内卡车", type: "single",require:true},
                        {code: "GNBG", name: "报关服务", type: "single",require:true},
                        {group: [
                                {code: "SEA", name: "海运服务", type: "single"},
                                {code: "RAILWAY", name: "铁路服务", type: "single"},
                                {code: "MORE", name: "多式联运", type: "single"}
                            ],
                            name: "港到港",
                            select: "radio",
                            type: "group",
                            require:true
                        },
                        {code: "GJBX", name: "国际保险", type: "single",require:false}
                    ],
                    title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList
                ]
            },
            2: {
                plan: [{
                    serviceList: [{code: "GNBG", name: "报关服务", type: "single",require:true}, {
                        group: [{code: "SEA",name: "海运服务",type: "single"},
                            {code: "RAILWAY", name: "铁路服务", type: "single"},
                            { code: "AIR",name: "空运服务", type: "single"},
                            {code: "MORE", name: "多式联运", type: "single"}],
                        name: "港到港",
                        select: "radio",
                        type: "group",
                        require:true
                    }, {code: "GJBX", name: "国际保险", type: "single",require:false}], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.grossWeight,
                    serviceRequireFiled.cbm,
                    serviceRequireFiled.ctns,
                ]
            }
        },
        EDQ: {
            1: {
                plan: [{
                    serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                        {code: "GNBG",name: "报关服务",type: "single",require:true},
                        {
                        group: [
                            {code: "SEA", name: "海运服务", type: "single"},
                            {code: "RAILWAY",name: "铁路服务",type: "single"},
                            {code: "MORE", name: "多式联运", type: "single"}
                        ],
                        name: "港到港",
                        select: "radio",
                        type: "group",
                        require:true
                    }, {code: "GJBX", name: "国际保险", type: "single",require:false},
                        {code: "QGFW",name: "清关服务",type: "single", require:true }
                    ], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList
                ]
            },
            2: {
                plan: [{
                    serviceList: [{code: "GNBG", name: "报关服务", type: "single",require:true}, {
                        group: [{ code: "SEA",name: "海运服务",type: "single"},
                            {code: "RAILWAY", name: "铁路服务", type: "single"},
                            {code: "AIR",name: "空运服务",type: "single" },
                            {code: "MORE", name: "多式联运", type: "single"}],
                        name: "港到港",select: "radio",type: "group",require:true
                    }, {code: "GJBX", name: "国际保险", type: "single",require:false},
                        {code: "QGFW",name: "清关服务",type: "single",require:true}
                    ], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.grossWeight,
                    serviceRequireFiled.cbm,
                    serviceRequireFiled.ctns,
                ]
            }
        },
        DAP: {
            1: {
                plan: [{
                    serviceList: [
                        {code: "GNKC", name: "国内卡车", type: "single",require:true},
                        {code: "GNBG", name: "报关服务", type: "single",require:true},
                        {
                            group: [
                                {code: "SEA", name: "海运服务", type: "single"},
                                {code: "RAILWAY", name: "铁路服务", type: "single"},
                                {code: "AIR", name: "空运服务", type: "single"},
                                {code: "MORE", name: "多式联运", type: "single"}
                            ],
                            name: "港到港", select: "radio", type: "group",require:true
                        },
                        {code: "GJBX", name: "国际保险", type: "single",require:false},
                        {code: "WCKC", name: "尾程卡车", type: "single",require:true}
                    ], title: "服务方案一"
                },
                    {
                        serviceList: [
                            {code: "GNKC", name: "国内卡车", type: "single",require:true},
                            {code: "GNBG", name: "报关服务", type: "single",require:true},
                            {code: "GJBX", name: "国际保险", type: "single",require:false},
                            {code: "DAP", name: "DAP门点服务", type: "single",require:true}
                        ], title: "服务方案二"
                    }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList,
                    serviceRequireFiled.fclArriveList,
                    serviceRequireFiled.region,
                    serviceRequireFiled.regionPost
                ]
            }
        },
        DDU: {
            1: {
                plan: [{
                    serviceList: [
                        {code: "GNKC", name: "国内卡车", type: "single",require:true},
                        { code: "GNBG",name: "报关服务",type: "single",require:true}, {
                        group: [{code: "SEA", name: "海运服务", type: "single"},
                            {code: "RAILWAY", name: "铁路服务", type: "single"
                        }, {code: "AIR", name: "空运服务", type: "single"},
                            {code: "MORE",name: "多式联运",type: "single"
                        }], name: "港到港", select: "radio", type: "group",require:true
                    }, {code: "GJBX", name: "国际保险", type: "single",require:false},
                        {code: "QGFW",name: "清关服务",type: "single",require:true },
                        {code: "WCKC", name: "尾程卡车", type: "single",require:true}], title: "服务方案一"
                },
                    {
                        serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                            {code: "GNBG",name: "报关服务",type: "single",require:true},
                            {code: "GJBX", name: "国际保险", type: "single",require:false},
                            {code: "DDU",name: "DDU门点服务",type: "single",require:true}],
                        title: "服务方案二"
                    }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList,
                    serviceRequireFiled.fclArriveList,
                    serviceRequireFiled.region,
                    serviceRequireFiled.regionPost
                ]
            }
        },
        DDP: {
            1: {
                plan: [{
                    serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                        {code: "GNBG",name: "报关服务",type: "single",require:true},
                        {
                        group: [{code: "SEA", name: "海运服务", type: "single"},
                            {code: "RAILWAY",name: "铁路服务",type: "single"},
                            {code: "AIR", name: "空运服务", type: "single"},
                            {code: "MORE",name: "多式联运",type: "single"}],
                            name: "港到港", select: "radio", type: "group",require:true
                    }, {code: "GJBX", name: "国际保险", type: "single",require:false},
                        {code: "QGFW",name: "清关服务", type: "single",require:true},
                        {code: "WCKC", name: "尾程卡车", type: "single",require:true}],
                    title: "服务方案一"
                },
                    {
                        serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                            {code: "GNBG",name: "报关服务",type: "single",require:true },
                            {code: "GJBX", name: "国际保险", type: "single",require:false},
                            {code: "DDP",name: "DDP门点服务",type: "single",require:true}], title: "服务方案二"
                    }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList,
                    serviceRequireFiled.fclArriveList,
                    serviceRequireFiled.region,
                    serviceRequireFiled.regionPost
                ]
            }
        },
        LDP: {
            1: {
                plan: [{
                    serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                        { code: "GNBG",name: "报关服务",type: "single",require:true},
                        {
                        group: [{code: "SEA", name: "海运服务", type: "single"},
                            {code: "RAILWAY",name: "铁路服务",type: "single"},
                            {code: "AIR", name: "空运服务", type: "single"},
                            {code: "MORE",name: "多式联运",type: "single"}],
                            name: "港到港", select: "radio", type: "group",require:true },
                        {code: "GJBX", name: "国际保险", type: "single",require:false},
                        {code: "QGFW",name: "清关服务",type: "single", require:true},
                        {code: "WCKC", name: "尾程卡车", type: "single",require:true}], title: "服务方案一"
                },
                    {
                        serviceList: [{code: "GNKC", name: "国内卡车", type: "single",require:true},
                            {code: "GNBG",name: "报关服务", type: "single",require:true},
                            {code: "GJBX", name: "国际保险", type: "single",require:false},
                            {code: "LDP",name: "LDP门点服务",type: "single",require:true}], title: "服务方案二"
                    }],
                require: [
                    serviceRequireFiled.departurePort,
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.fclInstallList,
                    serviceRequireFiled.fclArriveList,
                    serviceRequireFiled.region,
                    serviceRequireFiled.regionPost
                ]
            }
        },
        DTD: {
            2: {
                plan: [{
                    serviceList: [{
                        group: [
                            {code: "HK", name: "海卡", type: "single"},
                            {code: "HP", name: "海派", type: "single"},
                            {code: "KP", name: "卡派", type: "single"},
                            {code: "TP", name: "铁派", type: "single"},
                            {code: "KONGP", name: "空派", type: "single"},
                            {code: "KH", name: "卡航", type: "single"},
                            {code: "GJKD", name: "国际快递", type: "single"}
                        ],
                        name: "跨境物流",
                        select: "include",
                        code: "DTD",
                        type: "group",
                        require: true
                    }, {code: "KJBX", name: "跨境保险", type: "single",require:false}], title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.channelName,
                    serviceRequireFiled.category,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.refundOrNot,
                    serviceRequireFiled.arriveStore,
                    serviceRequireFiled.grossWeight,
                    serviceRequireFiled.cbm,
                    serviceRequireFiled.ctns,
                    serviceRequireFiled.region,
                    serviceRequireFiled.regionPost
                ]
            }
        },
        JK: {
            1: {
                plan: [{
                    serviceList: [{code: "QGFW", name: "清关服务", type: "single",require:true},
                        {code: "WCKC",name: "尾程卡车",type: "single",require:true}],
                    title: "服务方案"
                }],
                require: [
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.category,
                    serviceRequireFiled.regionFclArriveList,
                    serviceRequireFiled.regionPost
                ]
            },
            2: {
                plan: [{
                    serviceList: [{code: "QGFW", name: "清关服务", type: "single",require:true},
                        { code: "WCPS",name: "尾程派送",type: "single",require:true}], title: "服务方案"
                }],
                require:[
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.sendType,
                    serviceRequireFiled.region,
                    serviceRequireFiled.category,
                    serviceRequireFiled.regionPost
                ]
            }
        },
        EJ:{
            1:{
                plan: [{
                    serviceList: [{code: "QGFW", name: "清关服务", type: "single",require:false,requireOne:true},
                        {code: "WCKC",name: "尾程卡车",type: "single",require:false,requireOne:true}],
                    title: "服务方案"
                }],
                require:[
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.unit,
                    serviceRequireFiled.category,
                    serviceRequireFiled.region,
                    serviceRequireFiled.eta,
                    serviceRequireFiled.grossWeight,
                    serviceRequireFiled.cbm,
                    serviceRequireFiled.ctns,
                    serviceRequireFiled.productCardFclQueryList,
                ]
            },
            2:{
                plan:[
                    {serviceList:[
                        {code:"QGFW",name:"清关服务",type:"single"},
                            {code:"WCKC",name:"尾程卡车",type:"single"},
                            {code:"WCCG",name:"拆柜服务",type:"single",require:true}],title:"服务方案一"},
                    {serviceList:[
                        {code:"QGFW",name:"清关服务",type:"single"},
                            {code:"WCZH",name:"尾程组合",type:"single",require:true}],title:"服务方案二"}
                ],
                require: [
                    serviceRequireFiled.destinationPort,
                    serviceRequireFiled.cgStore,
                    serviceRequireFiled.unit,
                    serviceRequireFiled.category,
                    serviceRequireFiled.eta,
                    serviceRequireFiled.grossWeight,
                    serviceRequireFiled.cbm,
                    serviceRequireFiled.ctns,
                ]
            }
        }
    },
    goodsTypesFormat(val) {
        if (val == 1) {
            return '整柜';
        }
        if (val == 2) {
            return '散货';
        }
        if (val == 3) {
            return '整柜;散货'
        }

    },
    shippingTypesFormat(val) {
        if (!val) {
            return '';
        }

        var result = constants.shippingTypes.find(function (item, index, arr) {
            if (item.code == val) {
                return item;
            }
        })

        if (result) {
            return result.name;
        }
    }
    ,
    serviceTypesFormat: function (val) {
        if (!val) {
            return '';
        }

        var result = constants.serviceTypes.find(function (item, index, arr) {
            if (item.code == val) {
                return item;
            }
        })

        if (result) {
            return result.name;
        }
    },
    logisticsService:{
        GNKC: "国内卡车",
        GNBG: "报关服务",
        SEA: "海运服务",
        MORE: "多式联运",
        RAILWAY: "铁路服务",
        AIR: "空运服务",
        GJBX: "国际保险",
        QGFW: "清关服务",
        WCKC: "尾程卡车",
        DTD: "跨境物流",
        KJBX: "跨境保险",
        WCPS: "尾程派送",
        WCKD: "尾程快递",
        DAP: "DAP门点服务",
        DDU: "DDU门点服务",
        DDP: "DDP门点服务",
        LDP: "LDP门点服务",
        WCZH: "尾程组合服务",
        WCCG: "尾程拆柜服务",
        WCZT: "尾程自提服务",
    },
    serviceTag:{
        hasZgRegion: 1<<0,
        hasRegion:   1<<1,
    },
    // 1 包含国内部分 2 包含尾程部分
    service:{//              tagIndex:  3 2 1
        GNKC   :{code: "GNKC",    tag:0b0_0_1, name: "国内卡车"},
        GNBG   :{code: "GNBG",    tag:0b0_0_0, name: "报关服务"},
        GJBX   :{code: "GJBX",    tag:0b0_0_0, name: "国际保险"},
        SEA    :{code: "SEA",     tag:0b0_0_0, name: "海运服务"},
        RAILWAY:{code: "RAILWAY", tag:0b0_0_0, name: "铁路服务"},
        AIR    :{code: "AIR",     tag:0b0_0_0, name: "空运服务"},
        MORE   :{code: "MORE",    tag:0b0_0_0, name: "多式联运"},
        QGFW   :{code: "QGFW",    tag:0b0_0_0, name: "清关服务"},
        WCKC   :{code: "WCKC",    tag:0b0_1_0, name: "尾程卡车"},
        WCKD   :{code: "WCKD",    tag:0b0_0_0, name: "尾程快递"},
        WCPS   :{code: "WCPS",    tag:0b0_1_0, name: "尾程派送"},
        DAP    :{code: "DAP",     tag:0b0_1_1, name: "DAP门点服务"},
        DDP    :{code: "DDP",     tag:0b0_1_1, name: "DDP门点服务"},
        DDU    :{code: "DDU",     tag:0b0_1_1, name: "DDU门点服务"},
        LDP    :{code: "LDP",     tag:0b0_1_1, name: "LDP门点服务"},
        KP     :{code: "KP",      tag:0b0_1_0, name: "卡派"},
        HP     :{code: "HP",      tag:0b0_1_0, name: "海派"},
        HK     :{code: "HK",      tag:0b0_1_0, name: "海卡"},
        KONGP  :{code: "KONGP",   tag:0b0_1_0, name: "空派"},
        KH     :{code: "KH",      tag:0b0_1_0, name: "卡航"},
        TP     :{code: "TP",      tag:0b0_1_0, name: "铁派"},
        GJKD   :{code: "GJKD",    tag:0b0_1_0, name: "国际快递"},
        KJBX   :{code: "KJBX",    tag:0b0_0_0, name: "跨境保险"},
        WCZH: {code:"WCZH",name:"尾程组合"},
        WCCG: {code:"WCCG",name:"尾程拆柜"},
    },
    bulkloadContentList:[{contentType:"customerBillableGrossWeight",contentTitle:'计费体积(客户)'}, {contentType:"customerBillableVolume",contentTitle:"计费重量(客户)"},
        {contentType:"supplierBillableGrossWeight",contentTitle:'计费体积(供应商)'}, {contentType:"supplierBillableVolume",contentTitle:'计费重量(供应商)'}],
    wholeContentList:[{contentType:'allBoxVolume',contentTitle:'箱量（总）'}],

}

Object.freeze(constants);
Object.freeze(serviceRequireFiled);
export default constants
export const jsonHeader = {
    transformRequest: [data => JSON.stringify(data)],
    headers: {"Content-Type": "application/json; charset=UTF-8"},
}


// WEBPACK FOOTER //
// ./src/common/constants.js